<template>
    <CarConfirmAction :car="car">
        Вы действительно хотите отправить на согласование этот автомобиль?
    </CarConfirmAction>

    <div class="form__content">
        <div class="form-field">
            <UICheckbox
                v-model="form.auction_rules_accepted"
                :error-message="errors?.auction_rules_accepted?.join() ?? ''"
            >
                С <RulesLink>правилами аукциона</RulesLink> ознакомлен. Обязуемся оплатить вознаграждение за размещение автомобиля на аукционе в полном объеме
            </UICheckbox>
        </div>

        <span v-for="errorMessage in errorMessages" class="form-field__error">
            {{ errorMessage }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import { computed, Ref } from 'vue';
    import { inject } from '@vue/runtime-core';

    import { Car, CarSendForModerationForm, CarSendToModerationErrors } from '@/types/car.type.ts';

    import UICheckbox from '@/components/ui/UICheckbox/UICheckbox.vue';

    import RulesLink from '@/components/shared/RulesLink/RulesLink.vue';

    import CarConfirmAction from '@/components/cars/CarConfirmAction/CarConfirmAction.vue';

    const { car } = defineProps<{
        car: Car,
    }>();

    const form = inject('form', {}) as Ref<CarSendForModerationForm, CarSendForModerationForm>;
    const errors = inject('errors', {}) as Ref<CarSendToModerationErrors, CarSendToModerationErrors>;

    const errorMessages = computed<string[]>(() => {
        return (errors.value.photos ?? [])
            .concat(errors.value.videos ?? [])
            .concat(errors.value.documents ?? []);
    });
</script>
